import { render } from "./MfSubmittal.vue?vue&type=template&id=bc66e886"
import script from "./MfSubmittal.vue?vue&type=script&lang=js"
export * from "./MfSubmittal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__